import React from 'react';
import { AllergenTypes } from 'api/definitions/recipes/types';

import { ChipsGroup, Chip } from '@johnlewispartnership/wtr-ingredients/ingredients/Chips';
import { ProductTagType } from 'components/ProductPod2/utils';

import styles from './index.scss';

const allergensDefaultPropAllergens = [];

const Allergens = ({ allergens = allergensDefaultPropAllergens }) => {
  if (!allergens.length) return null;

  return (
    <div data-testid="allergens" className={styles.container}>
      <ChipsGroup>
        {allergens?.map(item => (
          <Chip colour={ProductTagType.GREEN} key={item.title}>
            {item.title}
          </Chip>
        ))}
      </ChipsGroup>
    </div>
  );
};
export default Allergens;

Allergens.propTypes = {
  allergens: AllergenTypes.allergens,
};
